import React from 'react';

export function CircleIcon() {
  // https://lucide.dev/icons/circle
  return (
    <g stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" />
    </g>
  );
}
